import { OnInit } from '@angular/core';
var LayoutComponent = /** @class */ (function () {
    function LayoutComponent() {
    }
    LayoutComponent.prototype.ngOnInit = function () { };
    return LayoutComponent;
}());
export { LayoutComponent };
